import { saveState, removeState } from "@lib/localStorage";
import { request } from "@lib/http";

export async function getInfo() {
    try {
        const response = await request('get', '/person', {});
        if (response.success) {
            removeState("user-data");
            saveState("user-data", response.data.user);
            return response.data;
        }
        return false;
        
    } catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};

export async function setVisibility(visible) {
    try {
        const response = await request('post', `/person/visibility`, {}, {visible});
        return response.success;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};

export async function setSettings(settings) {
    try {
        const response = await request('post', `/settings`, {}, settings);
        return response.success;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};

export async function upload_cv(data) {
    try {
        const response = await request('post', `/person/cv`, {'Content-Type': 'multipart/form-data'}, data);
        if (response.success) {
            return response
        }
        return { success: false }
    }
    catch (err) {
        console.log('Operation failed', err);
        return { success: false }
    }
};

export async function upload_img_profile(data) {
    try {
        const response = await request('post', `/person/picture`, {'Content-Type': 'multipart/form-data'}, data);
        if (response.success) {
            return response
        }
        return { success: false }
    }
    catch (err) {
        console.log('Operation failed', err);
        return { success: false }
    }
};

export async function delete_cv() {
    try {
        const response = await request('delete', `/person/cv`, {});
        if (response.success) {
            return response
        }
        return { success: false }
    }
    catch (err) {
        console.log('Operation failed', err);
        return { success: false }
    }
};

export async function edit_profile(data) {
    try {
        const response = await request('put', `/person`, {}, data);
        if (response.success) {
            return response
        }
        return { success: false }
    }
    catch (err) {
        console.log('Operation failed', err);
        return { success: false }
    }
};

/* Offer */
export async function like(offer_id) {
    try {
        const response = await request('post', `/offer/like`, {}, {offer_id});
        return response.success;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};

export async function unlike(offer_id) {
    try {
        const response = await request('delete', `/offer/unlike`, {}, {offer_id});
        return response.success;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};

export async function getFavoriteOffers(page) {
    try {
        const response = await request('get', `/offers/liked`, {page});
        if(response.success) return response.data;
        else return false;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};

export async function getOffer(offer_id) {
    try {
        const response = await request('get', `/offer/${offer_id}`);
        if(response.success) return response.data;
        else return false;
    }
    catch (error) {
        console.log('Operation failed', error);
        if(error.message.includes("404")) return 404;
        return false;
    }
};

export async function apply(offer_id) {
    try {
        const response = await request('post', `/offer/apply`, {}, {offer_id});
        return response.success;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};


export async function getOffers(searchQuery) {
    try {
        const response = await request('get', searchQuery, {});
        if(response.success) return response.data;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};
export async function searchOffers(searchQuery) {
    try {
        const response = await request('get', searchQuery, {});
        if(response.success) return response.data;
    }
    catch (error) {
        console.log('Operation failed', error);
        return false;
    }
};